// SPDX-License-Identifier: MIT

// Default copy for the banner. The actual strings live in strings.json (data
// only, easy to edit or translate); this just names them for importers. Sites
// override the banner/modal strings via the `text` option, and a consent type's
// label/description by setting them on the type (else the id defaults apply).

const strings = require('./strings.json');

module.exports = {
  DEFAULT_TEXT: strings.text,
  DEFAULT_CONSENT_TYPE_TEXT: strings.consentTypeText,
};
